import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ApplicationConfig } from './types'

export type ConfigState = {
  data?: ApplicationConfig
  fetching: boolean
  hasError: boolean
}

const initialState: ConfigState = {
  fetching: false,
  hasError: false
}

const configSlice = createSlice({
  initialState,
  name: 'config',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    fetch(state) {
      state.fetching = true
    },
    reset() {
      return initialState
    },
    setConfig(state, action: PayloadAction<ApplicationConfig>) {
      state.hasError = false
      state.fetching = false
      state.data = action.payload
    }
  }
})

export const { actions } = configSlice
export default configSlice.reducer
